import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'antd';

const NotFound = () => {
  return (
    <div>
      <div className='flex min-h-[70vh] items-center justify-center px-4 text-center sm:px-6 md:px-8 [&_h1]:text-[2.5rem] [&_h1]:leading-6 [&_h1]:font-semibold [&_h1]:text-[#596375] [&_h2]:text-base [&_h2]:text-[#596375]'>
        <div className='notfound'>
          <h1>Erro 404</h1>
          <h2>Ops, página não encontrada...</h2>
          <Link to={'/'}>
            <Button type='primary'>Ir para tela principal</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
